import React, {forwardRef, Fragment, useEffect, useImperativeHandle, useRef, useState} from "react";
import {
  Box,
  Dialog,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Paper,
  TextField,
  Tooltip,
  Typography,
  Radio,
  FormControlLabel, Stack
} from "@mui/material";
import {useTranslation} from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import {DateTimePicker} from '@mui/x-date-pickers';
import AvatarIcon from "@/components/avatar/AvatarIcon";
import {CancelButton, SavingButton} from "@/components/data-grid/CustomButton";
import PunchRecordService from "@/services/att/services/PunchRecordService";
import SnackbarUtil from "@/utils/SnackbarUtil";
import {ReactComponent as PendingIcon} from "@/assets/manual/Pending.svg";
import {ReactComponent as ApprovedIcon} from "@/assets/manual/Approved.svg";
import {ReactComponent as RejectedIcon} from "@/assets/manual/Rejected.svg";
import {ReactComponent as WithdrawnIcon} from "@/assets/manual/Withdrawn.svg";
import Util from "@/utils/Util";
import CompanyService from "@/services/auth/CompanyService";
import {parse} from "date-fns";

export function ApprovalAction({setInfo}: any) {
  const {t} = useTranslation()

  return (
    <Tooltip title={t("common.Approval")}>
      <IconButton sx={{"&:hover": {backgroundColor: "transparent"}}} onClick={() => {
        setInfo(true)
      }}>
        {/*<i className="icon iconfont icon-ic_view" style={{cursor: 'pointer', color: 'rgb(117, 130, 138)'}}></i>*/}
        {/*<span style={{*/}
        {/*  fontSize: '14px',*/}
        {/*  color: 'rgb(117, 130, 138)',*/}
        {/*  cursor: "pointer",*/}
        {/*  marginLeft: '4px',*/}
        {/*  marginTop: '-2px'*/}
        {/*}}>{t("common.Approval")}</span>*/}
      </IconButton>
    </Tooltip>
  )
}

const PunchApproval = (props: any, ref: any) => {
  const [info, setInfo] = useState<boolean>(false)
  const [state, setState] = useState({id: ""})
  const [stateView, setStateView] = useState({id: ""})
  useImperativeHandle(ref, () => ({
    showDetail: async (id: string) => {
      setState({id})
      setInfo(true)
      setStateView({id: ""})
    },
    showView: async (id: string) => {
      setStateView({id})
      setInfo(true)
      setState({id: ""})
    }
  }));
  const {t} = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [approveChecked, setApproveChecked] = useState(true);
  const [rejectChecked, setRejectChecked] = useState(false);
  const [finalTime, setFinalTime] = useState<Date>(new Date());
  const [comment, setComment] = useState<string>('');
  const [reserve, setReserve] = useState<any>([])
  const [approvalStatus, setApprovalStatus] = useState<any>('')
  const [data, setData] = useState<any>({})
  const [closeFlag, setCloseFlag] = useState(false);
  const [dateFormat, setDateFormat] = useState<string>("MM/dd/yyyy")
  useEffect(() => {
    CompanyService.dateFormat({method: 'get'}).then((res) => {
      const date_format = res.data?.date_format?.toString() || "MM/dd/yyyy";
      setDateFormat(date_format);
    });
  }, [state])

  useEffect(() => {
    if (state?.id || stateView?.id) {
      PunchRecordService.retrieve(state?.id || stateView?.id).then((res) => {
        setReserve(res.data.data?.approval_process)
        setApprovalStatus(res.data.data?.approval_status)
        setCloseFlag(res.data.data?.approval_process_close_flag)
        setData(res.data.data)
        // setFinalTime(res.data.data?.punch_time);
        const parsedDate = parse(
          res.data.data?.punch_time,
          `${dateFormat} HH:mm:ss`,
          new Date(),
        );
        setFinalTime(isNaN(parsedDate.getTime()) ? new Date() : parsedDate);
        setComment('')
      });
    }
  }, [state, stateView]);

  const handleApproveChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setApproveChecked(event.target.checked);
    if (event.target.checked) {
      setRejectChecked(false);
    }
  };

  const handleRejectChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRejectChecked(event.target.checked);
    if (event.target.checked) {
      setApproveChecked(false);
    }
  };
  const onSubmit = () => {
    setIsLoading(true)
    let requestPromise;
    if (approveChecked) {
      let post_data;
      if (Util.datetime2string(finalTime, "yyyy-MM-dd HH:mm:ss") !== data.punch_time) {
        post_data = {
          "id": state?.id,
          "comments": comment,
          "punch_time": Util.datetime2string(finalTime, "yyyy-MM-dd HH:mm:ss")
        }
      } else {
        post_data = {
          "id": state?.id,
          "comments": comment
        }
      }
      requestPromise = PunchRecordService.doApprove(post_data);
    } else {
      const post_data = {
        "id": state?.id,
        "comments": comment,
      }
      requestPromise = PunchRecordService.doReject(post_data);
    }
    requestPromise.then((res) => {
      if (res.status < 400) {
        SnackbarUtil.success(t("common.success"));
        if (props.reloadTable) {
          props.reloadTable()
        }
      }
    }).finally(() => {
      setIsLoading(false);
      setInfo(false)
    });
  }
  const ApprovalIcon = approvalStatus === 'approved' ? <ApprovedIcon/> :
    approvalStatus === 'pending' ? <PendingIcon/> :
      approvalStatus === 'rejected' ? <RejectedIcon/> : <WithdrawnIcon/>;
  const wfborderColor = approvalStatus === 'approved' ? '#7AC143' :
    approvalStatus === 'pending' ? '#2BA9DE' :
      approvalStatus === 'rejected' ? '#F2453B' : '#FCA265';
  const wfbackColor = approvalStatus === 'approved' ? '#F2F9ED' :
    approvalStatus === 'pending' ? '#EAF7FC' :
      approvalStatus === 'rejected' ? '#FEEDEC' : '#FFF6F0';

  return (
    <Fragment>
      <Grid item={true}>
        <ApprovalAction setInfo={setInfo}/>
      </Grid>
      <Dialog
        open={info}
        onClose={() => setInfo(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            height: 'auto',
            minHeight: data?.reserve ? '600px' : 'auto'
          }
        }}
      >
        <DialogTitle style={{
          marginBottom: "-25px",
          padding: "8px 24px 16px 24px",
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          color: '#999999'
        }}>
          <Typography variant="h6" fontWeight="bold">
            {t('common.Missed Punch Request')}
          </Typography>
          <IconButton
            aria-label="close"
            onClick={() => setInfo(false)}
            sx={{
              color: (theme) => theme.palette.grey[500]
            }}
          >
            <CloseIcon/>
          </IconButton>
        </DialogTitle>

        <Box sx={{p: 3, pt: 1}}>
          <Divider sx={{mb: 1, mt: 1}}/>

          {/* 审批详情区域 */}
          <Box mb={3}>
            <Typography
              variant="subtitle1"
              fontWeight="bold"
              sx={{color: '#333333', fontSize: "14px"}}
            >
              {t("common.Approval Details")}
            </Typography>

            <Grid container sx={{marginTop: "15px"}}>
              {/* 左侧内容区域 - 占8列 */}
              <Grid item xs={8}>
                {/* 第一行：Employee */}
                <Box sx={{display: 'flex', alignItems: 'center', mb: 2}}>
                  <Box sx={{width: '40%'}}>
                    <Typography variant="body2" sx={{color: '#999999', fontSize: "14px"}}>
                      {t("common.Employee")}
                    </Typography>
                  </Box>
                  <Box sx={{width: '60%'}}>
                    <Typography sx={{color: '#666666', fontSize: '14px'}}>
                      {data?.employee_name}
                    </Typography>
                  </Box>
                </Box>

                {/* 第二行：Corrected Time */}
                <Box sx={{display: 'flex', alignItems: 'center', mb: 2}}>
                  <Box sx={{width: '40%'}}>
                    <Typography variant="body2" sx={{color: '#999999', fontSize: '14px'}}>
                      {t("common.Corrected Time")}
                    </Typography>
                  </Box>
                  <Box sx={{width: '60%'}}>
                    <Typography sx={{color: '#666666', fontSize: '14px'}}>
                      {data?.punch_time}
                    </Typography>
                  </Box>
                </Box>

                {/* 第三行：Correction Reason */}
                <Box sx={{display: 'flex', alignItems: 'flex-start'}}>
                  <Box sx={{width: '40%'}}>
                    <Typography variant="body2" sx={{color: '#999999', fontSize: '14px'}}>
                      {t("common.Correction Reason")}
                    </Typography>
                  </Box>
                  <Box sx={{width: '60%'}}>
                    <Typography
                      sx={{
                        color: '#666666',
                        fontSize: '14px',
                        whiteSpace: 'pre-line'
                      }}
                    >
                      {data?.correction_reason || t("common.Null")}
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              {/* 右侧图标区域 - 占4列 */}
              <Grid item xs={4} sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                {ApprovalIcon}
              </Grid>
            </Grid>
          </Box>

          <Divider sx={{mb: 3}}/>

          {/* 审批流程区域 */}
          {data?.reserve && <Box mb={3}>
            <Typography
              variant="subtitle1"
              fontWeight="bold"
              mb={2}
              sx={{color: '#333333', fontSize: "14px"}}
            >
              {t("common.Approval Workflow")}
            </Typography>

            <Box sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
              {/* 循环内的Paper */}
              {reserve?.map((step: any, index: any) => {
                // 解析时间字符串
                const stepTime = new Date(step.time);
                const day = stepTime.getDate();
                const monthYear = `${stepTime.getFullYear()}-${String(stepTime.getMonth() + 1).padStart(2, '0')}`;
                const time = stepTime.toLocaleTimeString('en-US', {
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit',
                  hour12: false
                });

                // 根据status设置左边框颜色
                const borderColor = ['approved', 'Submitted', 'Approved'].includes(step.status) ? '#7AC143' :
                  step.status === 'pending' ? '#2BA9DE' :
                    step.status === 'rejected' ? '#F2453B' : '#FCA265';
                const backColor = ['approved', 'Submitted'].includes(step.status) ? '#F2F9ED' :
                  step.status === 'pending' ? '#EAF7FC' :
                    step.status === 'rejected' ? '#FEEDEC' : '#FFF6F0';

                return (
                  <Grid container key={index}>
                    {/* 左侧日期区域 - xs=2 */}
                    <Grid item xs={1.5}>
                      <Box
                        sx={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', position: 'relative'}}>
                        {/* 日期区域 */}
                        <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mb: 1}}>
                          <Typography
                            variant="h6"
                            fontWeight="bold"
                            sx={{color: '#666666', lineHeight: 1, fontSize: '16px'}}
                          >
                            {day}
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{color: '#999999', fontSize: '16px', fontWeight: 500}}
                          >
                            {monthYear}
                          </Typography>
                        </Box>

                        {/* 竖线和圆点 */}
                        <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                          {/* 上方圆点 */}
                          <Box
                            sx={{
                              width: '6px',
                              height: '6px',
                              borderRadius: '50%',
                              backgroundColor: '#e0e0e0',
                              mb: 0.5
                            }}
                          />

                          {/* 竖线 */}
                          <Box
                            sx={{
                              width: '2px',
                              height: '20px',
                              backgroundColor: '#e0e0e0',
                              marginLeft: '2px' // 让竖线与圆点对齐
                            }}
                          />

                          {/* 下方圆点 */}
                          <Box
                            sx={{
                              width: '6px',
                              height: '6px',
                              borderRadius: '50%',
                              backgroundColor: '#e0e0e0',
                              mt: 0.5
                            }}
                          />
                        </Box>
                      </Box>
                    </Grid>

                    {/* Paper内容区域 - xs=10 */}
                    <Grid item xs={10.5}>
                      <Paper
                        elevation={1}
                        sx={{
                          p: 2,
                          borderLeft: `4px solid ${borderColor}`,
                          borderRadius: '4px',
                          display: 'flex',
                          alignItems: 'flex-start',
                          justifyContent: 'space-between',
                          gap: 2,
                          backgroundColor: backColor,
                        }}
                      >
                        {/* 左侧：头像和人员信息 */}
                        <Box sx={{display: 'flex', alignItems: 'flex-start', gap: 2, flexGrow: 1}}>
                          <AvatarIcon name={step.employee_name}/>
                          <Box>
                            <Typography variant="body2" fontWeight="bold"
                                        sx={{color: '#666666', fontSize: '16px', mb: 0.5}}>
                              {step.employee_name}
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                color: borderColor,
                                fontWeight: 500,
                                fontSize: '14px'
                              }}
                            >
                              {step.status}
                            </Typography>
                            {step.change_log && <Typography
                              variant="body2"
                              sx={{
                                color: '#666666',
                                fontWeight: 500,
                                fontSize: '12px'
                              }}
                            >
                              {t('common.Change log')}: {step.change_log}
                            </Typography>}
                            {step.comments && <Typography
                              variant="body2"
                              sx={{
                                color: '#666666',
                                fontWeight: 500,
                                fontSize: '12px'
                              }}
                            >
                              {t('common.comments')}: {step.comments}
                            </Typography>}
                          </Box>
                        </Box>

                        {/* 右侧：角色和时间 */}
                        <Box sx={{textAlign: 'right', minWidth: '100px'}}>
                          <Typography variant="body2" sx={{fontSize: '12px', mb: 0.5, color: "#666666"}}>
                            {step.role}
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{color: '#999999', fontSize: '16px', fontWeight: 500}}
                          >
                            {time.split(' ')[0]}
                          </Typography>
                        </Box>
                      </Paper>
                    </Grid>
                  </Grid>
                );
              })}

              {closeFlag && <Grid container>
                <Grid item xs={1.5}>
                </Grid>
                <Grid item xs={10.5}>
                  <Paper
                    elevation={1}
                    sx={{
                      p: 2,
                      borderLeft: `4px solid ${wfborderColor}`,
                      borderRadius: '4px',
                      display: 'flex',
                      alignItems: 'flex-start',
                      justifyContent: 'space-between',
                      gap: 2,
                      backgroundColor: wfbackColor,
                    }}
                  >
                    <Typography sx={{color: "#666666", fontSize: "16px"}}>{t("common.workflow completed")}</Typography>
                  </Paper>
                </Grid>
              </Grid>}
            </Box>
          </Box>}

          {!stateView?.id && <Divider sx={{mb: 3}}/>}

          {/* 审批处理区域 */}
          {!stateView?.id && <Box sx={{flex: 1, minHeight: '200px'}}>
            <Typography
              variant="subtitle1"
              fontWeight="bold"
              mb={2}
              sx={{color: '#333333', fontSize: "14px"}}
            >
              {t("common.Approval Processing")}
            </Typography>

            {/* 审批选择 */}
            <Box sx={{display: 'flex', gap: 3, mb: 3}}>
              <FormControlLabel
                control={
                  <Radio
                    checked={approveChecked}
                    onChange={handleApproveChange}
                    sx={{
                      color: '#2BA9DE',
                      '&.Mui-checked': {
                        color: '#2BA9DE',
                      },
                    }}
                  />
                }
                label={t("common.Approve")}
                sx={{'& .MuiFormControlLabel-label': {color: '#3D3D3D'}}}
              />
              <FormControlLabel
                control={
                  <Radio
                    checked={rejectChecked}
                    onChange={handleRejectChange}
                    sx={{
                      color: '#2BA9DE',
                      '&.Mui-checked': {
                        color: '#2BA9DE',
                      },
                    }}
                  />
                }
                label={t("common.Reject")}
                sx={{'& .MuiFormControlLabel-label': {color: '#3D3D3D'}}}
              />
            </Box>

            {/* 最终时间 */}
            {(approveChecked && data?.punch_state === '1001') && <Box sx={{
              height: approveChecked ? 'auto' : '0px',
              overflow: 'hidden',
              transition: 'height 0.3s ease',
              mb: approveChecked ? 3 : 0
            }}>
              <Grid sx={{display: "flex", marginBottom: "10px"}}>
                <Typography variant="body2" gutterBottom sx={{color: "#666666", fontSize: "14px"}}>
                  {t("common.Final Time")}
                </Typography>
              </Grid>
              <DateTimePicker<Date>
                value={finalTime}
                inputFormat={`${dateFormat} HH:mm:ss`}
                disableFuture={true}
                onChange={(newValue: Date | null) => {
                  setFinalTime(newValue || new Date())
                }}
                renderInput={(params) => {
                  return (
                    <TextField
                      sx={{width: '30%', color: "#3D3D3D", fontSize: "14px"}}
                      {...params}
                    />
                  )
                }}
              />
            </Box>}

            <Box>
              <Typography variant="body2" gutterBottom sx={{color: "#666666", fontSize: "14px"}}>
                {t("common.Comment")}
              </Typography>
              <TextField
                multiline
                rows={3}
                placeholder={t("common.Please enter your comment")}
                fullWidth
                value={comment}
                variant="outlined"
                size="small"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#FFFFFF',
                    fontSize: "14px",
                  },
                  '& .MuiOutlinedInput-input': {
                    color: '#333333',
                  },
                  '& .MuiInputBase-input::placeholder': {
                    color: '#CCCCCC',
                    opacity: 1,
                  }
                }}
                onChange={(event: any) => {
                  setComment(event.target.value)
                }}
              />
            </Box>
          </Box>}
        </Box>
        {!stateView?.id && <Grid item xs={12} sx={{padding: "16px 24px 8px 24px",}}>
          <Stack spacing={3} direction={"row"} justifyContent="flex-end">
            <CancelButton onClick={() => {
              setInfo(false)
            }}/>
            <SavingButton loading={isLoading} onClick={onSubmit} children={t("common.submit")}/>
          </Stack>
        </Grid>}
      </Dialog>
    </Fragment>
  )
}

export default forwardRef(PunchApproval);
